import React from 'react';
import SectionHeader from '@components/common/SectionHeader';
import type { DividendInfoBlockData } from '@app-types/performanceDividend';

export interface DividendKeyValueTableProps {
  data: DividendInfoBlockData;
}

/**
 * Key/value table card for dividend info and related schedule blocks.
 * Figma: dividend info 3132:3262–3264, schedule 3132:3270–3272.
 * Uses SectionHeader (showHelp) + a semantic table with 1px grid.
 */
const DividendKeyValueTable: React.FC<DividendKeyValueTableProps> = ({ data }) => (
  <div className="dividend-card" data-node-id={data.sectionNodeId}>
    <SectionHeader
      title={data.title}
      showHelp
      dataNodeId={data.headerNodeId}
      as="h3"
    />
    <table
      className="dividend-kv-table"
      data-node-id={data.tableNodeId}
    >
      <caption className="dividend-kv-table__caption">{data.title}</caption>
      <tbody>
        {data.rows.map((row) => (
          <tr key={row.key} data-node-id={row.nodeId}>
            <th scope="row" className="dividend-kv-table__label">
              {row.label}
            </th>
            <td className="dividend-kv-table__value">{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DividendKeyValueTable;
